import { useEffect, useState, type ChangeEvent } from "react";
import ModalDialog, {
  ModalDialogBody,
  ModalDialogFooter,
} from "../UI/ModalDialog";
import Button from "../UI/Button";
// @ts-expect-error pure js
import TextInputStandalone from "../UI/TextInputStandalone";
import { toDateTimeLocal } from "../../utils/candidature";

interface VisitDateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialDate: string | null | undefined;
  onSubmit: (date: string | null) => void;
}

export default function VisitDateDialog({
  open,
  onOpenChange,
  initialDate,
  onSubmit,
}: VisitDateDialogProps) {
  const [value, setValue] = useState(() => toDateTimeLocal(initialDate));

  useEffect(() => {
    if (open) setValue(toDateTimeLocal(initialDate));
  }, [open, initialDate]);

  const incomplete = value !== "" && value.length < 16;

  return (
    <ModalDialog
      open={open}
      onOpenChange={onOpenChange}
      size="xs"
      header="Date de la visite"
      subtitle="Laissez vide si la date n'est pas encore fixée."
    >
      <ModalDialogBody>
        <TextInputStandalone
          label="Date et heure"
          name="visit_date"
          type="datetime-local"
          value={value}
          onChange={(event: ChangeEvent<HTMLInputElement>) =>
            setValue(event.target.value)
          }
        />
      </ModalDialogBody>
      <ModalDialogFooter>
        <Button
          type="button"
          variant="secondary"
          onClick={() => onOpenChange(false)}
        >
          Annuler
        </Button>
        <Button
          type="button"
          disabled={incomplete}
          onClick={() => onSubmit(value === "" ? null : value)}
        >
          Valider
        </Button>
      </ModalDialogFooter>
    </ModalDialog>
  );
}
